// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — label.styled.classic.js, новая — label.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './label.styled.classic';
import * as cp from './label.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
